import "./posts.css";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import fishmonsterImage from "../../assets/Assetstest/fishmonster.png"; 
import axios from "axios";
import ReactTimeAgo from "react-time-ago";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";
import ru from "javascript-time-ago/locale/ru.json";

TimeAgo.addDefaultLocale(en);
TimeAgo.addLocale(ru);
interface Player {
  name: string;
  avatar: string | null; 
}
interface PostAuthorProps {
  playerID: string | number;
  createdAt: string;
  avatar?: string;
  name?: string;
}

export const PostAuthor = ({ playerID, createdAt, avatar, name }: PostAuthorProps) => {
  const [player, setPlayer] = useState<Player | null>(null);

  useEffect(() => {
    const getPlayer = async () => {
      if (typeof playerID !== 'string' && typeof playerID !== 'number') {
        console.error("Invalid playerID:", playerID);
        return;
      }
      try {
        const response = await axios.get<Player>(`${process.env.REACT_APP_BASE_URL}/users/${playerID}`);
        setPlayer(response?.data);
      } catch (error: any) {
        console.error("Error fetching player data:", error?.message || error);
      }
    };

    if (!name || !avatar) {
      getPlayer();
    }
  }, [playerID, name, avatar]);

  return (
    <Link to={`/posts/users/${playerID}`} className="post__author">
      <div className="post__author-avatar">
        <img
          className="post-author__avatar"
          src={avatar || player?.avatar || fishmonsterImage}
          alt="user avatar"
        />
      </div>
      <div className="post__author-details">
        <h5>By: {name || player?.name || "Unknown User"}</h5>
        {createdAt && <small><ReactTimeAgo date={new Date(createdAt)} locale='en-US' /></small>}
      </div>
    </Link>
  );
};
